import { useGuestSiteTelemetry } from '@apps/guest/GuestSite.telemetry';
import { EventPageFragment } from '@graphql/generated';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from '@shared/core';

const slugFromPathname = (pathname: string) => pathname.split('/')[2];

export const useGuestSitePageChanged = (pages: Array<EventPageFragment>, trackOnFirstRender = false) => {
  const telemetry = useGuestSiteTelemetry();
  const [currentPageSlug, setCurrentPageSlug] = useState<string>();

  const history = useHistory();

  const trackPage = useCallback(
    locationPathName => {
      const pageFound = pages.find(p => p.pageSlug === slugFromPathname(locationPathName));

      if (pageFound && telemetry[pageFound.pageSlug] && currentPageSlug !== pageFound.pageSlug) {
        if (currentPageSlug && telemetry[currentPageSlug]) {
          telemetry[currentPageSlug].exit();
        }

        telemetry[pageFound.pageSlug].enter();
        setCurrentPageSlug(pageFound.pageSlug);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pages, history, currentPageSlug]
  );

  useEffect(() => {
    if (trackOnFirstRender && history.location.pathname) {
      trackPage(history.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const unlisten = history.listen(location => {
      trackPage(location.pathname);
    });
    return () => {
      unlisten();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, pages, currentPageSlug]);
};
